import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, ClockIcon, BuildingIcon, CalendarIcon, CheckIcon, HeartIcon, InfoIcon, StarIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';
const InvestorView = () => {
  const [investmentAmount, setInvestmentAmount] = useState(1000);
  return <div className="max-w-4xl mx-auto" data-id="element-444">
      <div className="mb-6" data-id="element-445">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-446">
          Investor Marketplace
        </h1>
        <p className="text-neutral-400" data-id="element-447">
          Discover Shariah-compliant investment opportunities
        </p>
      </div>
      {/* Featured Sukuk */}
      <section className="mb-8" data-id="element-448">
        <Card data-id="element-449">
          <div className="flex flex-col md:flex-row gap-6" data-id="element-450">
            {/* Business Profile */}
            <div className="md:w-1/3" data-id="element-451">
              <div className="h-48 bg-cover bg-center rounded-lg mb-4" style={{
              backgroundImage: "url('https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
            }} data-id="element-452"></div>
              <h3 className="font-bold text-lg mb-2" data-id="element-453">Amani Cafe</h3>
              <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-454">
                <MapPinIcon className="w-4 h-4 mr-1" data-id="element-455" />
                <span data-id="element-456">Kuala Lumpur</span>
              </div>
              <div className="flex items-center mb-4" data-id="element-457">
                <div className="flex" data-id="element-458">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className={`w-4 h-4 ${star <= 4 ? 'text-accent' : 'text-neutral-200'}`} fill={star <= 4 ? 'currentColor' : 'none'} data-id="element-459" />)}
                </div>
                <span className="text-xs text-neutral-400 ml-2" data-id="element-460">
                  4.0 (23 reviews)
                </span>
              </div>
              <div className="bg-neutral-50 p-3 rounded-lg mb-4" data-id="element-461">
                <div className="text-sm font-medium mb-1" data-id="element-462">Business Details</div>
                <div className="space-y-2 text-sm" data-id="element-463">
                  <div className="flex justify-between" data-id="element-464">
                    <span className="text-neutral-400" data-id="element-465">Type</span>
                    <span data-id="element-466">Coffee Shop</span>
                  </div>
                  <div className="flex justify-between" data-id="element-467">
                    <span className="text-neutral-400" data-id="element-468">Years Active</span>
                    <span data-id="element-469">3+ Years</span>
                  </div>
                  <div className="flex justify-between" data-id="element-470">
                    <span className="text-neutral-400" data-id="element-471">Team Size</span>
                    <span data-id="element-472">8 Employees</span>
                  </div>
                </div>
              </div>
              <div className="bg-secondary bg-opacity-5 p-3 rounded-lg" data-id="element-473">
                <div className="text-sm font-medium text-secondary mb-1" data-id="element-474">
                  Risk Rating
                </div>
                <div className="flex items-center" data-id="element-475">
                  <span className="text-success font-medium mr-2" data-id="element-476">
                    Low Risk
                  </span>
                  <div className="w-full bg-neutral-200 rounded-full h-1.5" data-id="element-477">
                    <div className="bg-success h-1.5 rounded-full" style={{
                    width: '25%'
                  }} data-id="element-478"></div>
                  </div>
                </div>
              </div>
            </div>
            {/* Sukuk Details */}
            <div className="md:w-2/3" data-id="element-479">
              <div className="flex justify-between items-start mb-4" data-id="element-480">
                <div data-id="element-481">
                  <h2 className="text-xl font-bold" data-id="element-482">
                    Equipment Financing Micro-Sukuk
                  </h2>
                  <p className="text-neutral-400" data-id="element-483">Sukuk ID: MS2023-104</p>
                </div>
                <div className="bg-primary bg-opacity-10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-484">
                  New Listing
                </div>
              </div>
              <p className="text-sm mb-6" data-id="element-485">
                Amani Cafe is seeking financing to purchase a new professional
                espresso machine and coffee grinder. This equipment will allow
                them to expand their beverage menu offerings and improve service
                efficiency during peak hours. The business expects to increase
                daily coffee sales by 30% with this investment.
              </p>
              <div className="mb-6" data-id="element-486">
                <div className="flex justify-between text-sm mb-1" data-id="element-487">
                  <span data-id="element-488">Funding Progress</span>
                  <span data-id="element-489">40% (RM 10,000 of RM 25,000)</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2.5 mb-1" data-id="element-490">
                  <div className="bg-primary h-2.5 rounded-full" style={{
                  width: '40%'
                }} data-id="element-491"></div>
                </div>
                <div className="flex justify-between text-xs text-neutral-400" data-id="element-492">
                  <div className="flex items-center" data-id="element-493">
                    <UsersIcon className="w-3 h-3 mr-1" data-id="element-494" />
                    <span data-id="element-495">8 Investors</span>
                  </div>
                  <div className="flex items-center" data-id="element-496">
                    <ClockIcon className="w-3 h-3 mr-1" data-id="element-497" />
                    <span data-id="element-498">14 days remaining</span>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-id="element-499">
                <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-500">
                  <div className="text-xs text-neutral-400" data-id="element-501">Amount</div>
                  <div className="font-medium" data-id="element-502">RM 25,000</div>
                </div>
                <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-503">
                  <div className="text-xs text-neutral-400" data-id="element-504">Term</div>
                  <div className="font-medium" data-id="element-505">6 months</div>
                </div>
                <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-506">
                  <div className="text-xs text-neutral-400" data-id="element-507">Profit Rate</div>
                  <div className="font-medium" data-id="element-508">12% p.a.</div>
                </div>
                <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-509">
                  <div className="text-xs text-neutral-400" data-id="element-510">
                    Min. Investment
                  </div>
                  <div className="font-medium" data-id="element-511">RM 100</div>
                </div>
              </div>
              <div className="border border-neutral-100 rounded-lg p-4 mb-6" data-id="element-512">
                <h4 className="font-medium mb-3" data-id="element-513">Community Rewards</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-514">
                  <div className="bg-accent bg-opacity-5 border border-accent border-opacity-20 rounded-lg p-3" data-id="element-515">
                    <div className="flex items-center mb-2" data-id="element-516">
                      <div className="w-8 h-8 rounded-full bg-accent bg-opacity-10 flex items-center justify-center mr-2" data-id="element-517">
                        <HeartIcon className="w-4 h-4 text-accent" data-id="element-518" />
                      </div>
                      <div className="font-medium" data-id="element-519">10% Off Any Coffee</div>
                    </div>
                    <p className="text-xs text-neutral-500 mb-2" data-id="element-520">
                      Investors can enjoy 10% off any coffee purchase by showing
                      their investment certificate.
                    </p>
                    <div className="flex items-center text-xs text-neutral-400" data-id="element-521">
                      <CalendarIcon className="w-3 h-3 mr-1" data-id="element-522" />
                      <span data-id="element-523">Valid until: Dec 31, 2023</span>
                    </div>
                  </div>
                  <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-3" data-id="element-524">
                    <div className="flex items-center mb-2" data-id="element-525">
                      <div className="w-8 h-8 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-526">
                        <TrendingUpIcon className="w-4 h-4 text-primary" data-id="element-527" />
                      </div>
                      <div className="font-medium" data-id="element-528">Impact Investor Badge</div>
                    </div>
                    <p className="text-xs text-neutral-500 mb-2" data-id="element-529">
                      Earn a digital badge recognizing your support of local
                      businesses and community development.
                    </p>
                    <div className="flex items-center text-xs text-primary font-medium" data-id="element-530">
                      <CheckIcon className="w-3 h-3 mr-1" data-id="element-531" />
                      <span data-id="element-532">Permanent Benefit</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-6" data-id="element-533">
                <h4 className="font-medium mb-3" data-id="element-534">Your Investment</h4>
                <div className="mb-4" data-id="element-535">
                  <label className="block text-sm mb-2" data-id="element-536">
                    Investment Amount (RM)
                  </label>
                  <input type="range" min="100" max="5000" step="100" value={investmentAmount} onChange={e => setInvestmentAmount(parseInt(e.target.value))} className="w-full h-2 bg-neutral-200 rounded-lg appearance-none cursor-pointer" data-id="element-537" />
                  <div className="flex justify-between text-xs text-neutral-400 mt-1" data-id="element-538">
                    <span data-id="element-539">Min: RM 100</span>
                    <span data-id="element-540">Max: RM 5,000</span>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-541">
                  <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-542">
                    <div className="text-xs text-neutral-400" data-id="element-543">
                      Your Investment
                    </div>
                    <div className="font-medium text-primary" data-id="element-544">
                      RM {investmentAmount.toLocaleString()}
                    </div>
                  </div>
                  <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-545">
                    <div className="text-xs text-neutral-400" data-id="element-546">
                      Expected Return
                    </div>
                    <div className="font-medium text-primary" data-id="element-547">
                      RM{' '}
                      {Math.round(investmentAmount * 0.12 * (6 / 12)).toLocaleString()}
                    </div>
                  </div>
                  <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-548">
                    <div className="text-xs text-neutral-400" data-id="element-549">
                      Maturity Amount
                    </div>
                    <div className="font-medium text-primary" data-id="element-550">
                      RM{' '}
                      {Math.round(investmentAmount * (1 + 0.05 * (6 / 12))).toLocaleString()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row justify-end gap-3" data-id="element-551">
                <Button variant="outline" data-id="element-552">Learn More</Button>
                <Link to="/investor-portal" data-id="element-553">
                  <Button variant="primary" data-id="element-554">Invest Now</Button>
                </Link>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Other Opportunities */}
      <section data-id="element-555">
        <h2 className="text-xl font-bold mb-4" data-id="element-556">Other Opportunities</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-557">
          {/* Card 1 */}
          <Card padding="none" className="overflow-hidden" data-id="element-558">
            <div className="h-40 bg-cover bg-center" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1604719312566-8912e9227c6a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
          }} data-id="element-559"></div>
            <div className="p-4" data-id="element-560">
              <div className="flex justify-between items-start mb-3" data-id="element-561">
                <h3 className="font-bold" data-id="element-562">GreenTech Solutions</h3>
                <div className="bg-success bg-opacity-10 text-success px-2 py-1 rounded text-xs font-medium" data-id="element-563">
                  Eco-friendly
                </div>
              </div>
              <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-564">
                <MapPinIcon className="w-4 h-4 mr-1" data-id="element-565" />
                <span data-id="element-566">Penang</span>
              </div>
              <p className="text-sm mb-4" data-id="element-567">
                Sustainable products manufacturer seeking inventory financing
                for upcoming orders.
              </p>
              <div className="mb-4" data-id="element-568">
                <div className="flex justify-between text-sm mb-1" data-id="element-569">
                  <span data-id="element-570">Funding Progress</span>
                  <span data-id="element-571">40% (RM 20,000)</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-572">
                  <div className="bg-primary h-2 rounded-full" style={{
                  width: '40%'
                }} data-id="element-573"></div>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-574">
                <div className="text-sm font-medium" data-id="element-575">RM 50,000 • 9 months</div>
                <Button variant="outline" size="sm" data-id="element-576">
                  View
                </Button>
              </div>
            </div>
          </Card>
          {/* Card 2 */}
          <Card padding="none" className="overflow-hidden" data-id="element-577">
            <div className="h-40 bg-cover bg-center" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
          }} data-id="element-578"></div>
            <div className="p-4" data-id="element-579">
              <div className="flex justify-between items-start mb-3" data-id="element-580">
                <h3 className="font-bold" data-id="element-581">Modest Fashion House</h3>
                <div className="bg-secondary bg-opacity-10 text-secondary px-2 py-1 rounded text-xs font-medium" data-id="element-582">
                  Retail
                </div>
              </div>
              <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-583">
                <MapPinIcon className="w-4 h-4 mr-1" data-id="element-584" />
                <span data-id="element-585">Johor Bahru</span>
              </div>
              <p className="text-sm mb-4" data-id="element-586">
                Modest fashion brand expanding to a new location and increasing
                inventory.
              </p>
              <div className="mb-4" data-id="element-587">
                <div className="flex justify-between text-sm mb-1" data-id="element-588">
                  <span data-id="element-589">Funding Progress</span>
                  <span data-id="element-590">80% (RM 64,000)</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-591">
                  <div className="bg-primary h-2 rounded-full" style={{
                  width: '80%'
                }} data-id="element-592"></div>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-593">
                <div className="text-sm font-medium" data-id="element-594">RM 80,000 • 12 months</div>
                <Button variant="outline" size="sm" data-id="element-595">
                  View
                </Button>
              </div>
            </div>
          </Card>
          {/* Card 3 */}
          <Card padding="none" className="overflow-hidden" data-id="element-596">
            <div className="h-40 bg-cover bg-center" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
          }} data-id="element-597"></div>
            <div className="p-4" data-id="element-598">
              <div className="flex justify-between items-start mb-3" data-id="element-599">
                <h3 className="font-bold" data-id="element-600">Halal Delights</h3>
                <div className="bg-accent bg-opacity-10 text-accent px-2 py-1 rounded text-xs font-medium" data-id="element-601">
                  Restaurant
                </div>
              </div>
              <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-602">
                <MapPinIcon className="w-4 h-4 mr-1" data-id="element-603" />
                <span data-id="element-604">Kuala Lumpur</span>
              </div>
              <p className="text-sm mb-4" data-id="element-605">
                Family restaurant seeking working capital for seasonal menu
                expansion and kitchen upgrades.
              </p>
              <div className="mb-4" data-id="element-606">
                <div className="flex justify-between text-sm mb-1" data-id="element-607">
                  <span data-id="element-608">Funding Progress</span>
                  <span data-id="element-609">25% (RM 8,750)</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-610">
                  <div className="bg-primary h-2 rounded-full" style={{
                  width: '25%'
                }} data-id="element-611"></div>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-612">
                <div className="text-sm font-medium" data-id="element-613">RM 35,000 • 6 months</div>
                <Button variant="outline" size="sm" data-id="element-614">
                  View
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </div>;
};
export default InvestorView;